// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"493":"bf5f3635","912":"d279225f"}[chunkId] || chunkId) + "." + {"289":"01fced50a17321e0","493":"fc3abb014c083112","719":"d416ecd731a44121","912":"b31c99bfdc3bde55"}[chunkId] + ".js";
};